import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import moment from "moment";

const WAITER_BUTTON_DISABLED_INTERVAL = 1;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AlertDialogSlide({
  onClose,
  onClick,
  language,
  last_waiter_request,
  setLastWaiterRequest,
}) {
  const waiterButtonDisabled = () => {
    if (last_waiter_request) {
      if (
        moment(last_waiter_request, "YYYY-MM-DD HH:mm:ss").add(
          WAITER_BUTTON_DISABLED_INTERVAL,
          "minutes"
        ) > moment()
      ) {
        return true;
      }
    }
    return false;
  };
  return (
    <div>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language === "arabic" ? "طلب موظف خدمة" : "Request a waiter"}
        </DialogTitle>
        <DialogContent>
          {waiterButtonDisabled() ? (
            <DialogContentText
              id="alert-dialog-slide-description"
              style={{ textAlign: language == "english" ? "left" : "right" }}
            >
              {language === "arabic"
                ? "الرجاء الانتظار لمدة دقيقتين قبل اعادة الطلب"
                : "Please wait for 2 minutes before requesting a waiter again"}
            </DialogContentText>
          ) : (
            <DialogContentText
              id="alert-dialog-slide-description"
              style={{ textAlign: language == "english" ? "left" : "right" }}
            >
              {language === "arabic"
                ? "سيتم ارسال اشعار لموظفي الخدمة بحاجتك الى مساعدة. متابعة؟"
                : "Are you sure you need the help of a waiter?"}
            </DialogContentText>
          )}
        </DialogContent>
        {waiterButtonDisabled() ? (
          <DialogActions
            style={{
              justifyContent: language == "english" ? "flex-end" : "flex-start",
            }}
          >
            <Button onClick={onClose}>
              {language === "arabic" ? "حسنا" : "Ok"}
            </Button>
          </DialogActions>
        ) : (
          <DialogActions
            style={{
              justifyContent: language == "english" ? "flex-end" : "flex-start",
            }}
          >
            <Button onClick={onClose}>
              {language === "arabic" ? "لا" : "No"}
            </Button>
            <Button
              onClick={() => {
                setLastWaiterRequest(moment().format("YYYY-MM-DD HH:mm:ss"));
                onClick();
              }}
            >
              {language === "arabic" ? "نعم" : "Yes"}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    last_waiter_request: state.promise.last_waiter_request,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLastWaiterRequest: (ts) =>
      dispatch({ type: "SET_LAST_WAITER_REQUEST", payload: ts }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AlertDialogSlide);
